// Genre abbreviation map for compact display contexts (cards, tags on mobile).
// Full names are preserved for content pages, filters, and detail views.
//
// SUBGENRE abbreviations are NOT defined here — they live on the canonical
// entries in data/subgenreRegistry.ts so each subgenre has one home. This map
// now only covers top-level genres and non-subgenre labels the registry does
// not own (age categories, formats, etc.).
import { getSubgenreAbbreviation, getSubgenreEntry } from '../data/subgenreRegistry'

const GENRE_ABBREVIATIONS: Record<string, string> = {
  // Top-level genres
  'Science Fiction': 'Sci-Fi',
  'Historical Fiction': 'Hist. Fiction',
  'Literary Fiction': 'Lit. Fiction',
  'Contemporary Fiction': 'Cont. Fiction',
  'General Fiction': 'Gen. Fiction',
  'Science Fantasy': 'Sci-Fantasy',

  // Age categories
  'Young Adult': 'YA',
  'Young Adult Romance': 'YA Romance',
  'New Adult': 'NA',

  // Labels the registry does not own
  'Mystery Thriller': 'Myst. Thriller',
  'Paranormal Fantasy': 'Para. Fant.',
  'Fantasy Adventure': 'Fant. Adv.',
  'Shifter Romance': 'Shifter Rom.',
  'Science Fiction Erotica': 'Sci-Fi Erotica',
  'Non-Fiction': 'Non-Fiction',
  'Self-Help': 'Self-Help',
  'Graphic Novel': 'Graphic Novel',
}

/**
 * Returns an abbreviated version of a genre/subgenre string for compact display.
 * Subgenres resolve through the canonical registry (which also understands
 * legacy labels); everything else falls back to the local genre map.
 */
export function abbreviateGenre(genre: string): string {
  if (!genre) return genre
  if (getSubgenreEntry(genre)) return getSubgenreAbbreviation(genre)
  return GENRE_ABBREVIATIONS[genre] ?? genre
}

export default GENRE_ABBREVIATIONS
